import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import sellerCategoryService from 'services/seller/category';

const initialState = {
  loading: false,
  categories: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchSellerCategories = createAsyncThunk(
  'sellerCategory/fetchSellerCategories',
  (params = {}) => {
    return sellerCategoryService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

const sellerCategorySlice = createSlice({
  name: 'sellerCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSellerCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerCategories.fulfilled, (state, action) => {
      const { payload } = action;
      const items = payload.data ?? [];
      const meta = payload.meta ?? {};
      state.loading = false;
      state.categories = items.map((item) => ({
        active: item.active,
        img: item.img,
        name: item.translation !== null ? item.translation.title : 'no name',
        key: item.uuid + '_' + item.id,
        uuid: item.uuid,
        id: item.id,
        locales: item.locales,
        deleted_at: item?.deleted_at,
        status: item.status,
        shop: item.shop,
        shop_id: item.shop_id,
      }));
      state.meta = meta;
      state.params.page = meta.current_page;
      state.params.perPage = meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchSellerCategories.rejected, (state, action) => {
      state.loading = false;
      state.categories = [];
      state.error = action.error.message;
    });
  },
});

export default sellerCategorySlice.reducer;
